export default __webpack_public_path__ + "static/media/house.c7acb482.jpg";